import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})

export class AdminSetupService {
  private baseURL: string;
  constructor(private http: HttpClient) {
    this.baseURL = environment.apiBaseUrl;
  }
 
  private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

   getRentalSettings(marketId): Observable<boolean> {
    return this.http.get<any>(
        `${this.baseURL}/admin/Setup/GetRentalSettingsDetails?marketId=` + marketId,
        { observe: 'response' })
        .pipe(
          map(res => {
            const rentalSettings = res.body as any;
            return rentalSettings;
          }),
          catchError(this.handleError)
        );
   }

   getRentalTypes(): Observable<boolean> {
    return this.http.get<any>(
        `${this.baseURL}/admin/Setup/GetRentalTypes`,
        { observe: 'response' })
        .pipe(
          map(res => {
            const rentalSettings = res.body as any;
            return rentalSettings;
          }),
          catchError(this.handleError)
        );
   }

   getOtherRentalCharges(marketId): Observable<boolean> {
    return this.http.get<any>(
        `${this.baseURL}/admin/Setup/GetOtherRentalCharges?marketId=` + marketId,
        { observe: 'response' })
        .pipe(
          map(res => {
            const rentalOtherCharges = res.body as any;
            return rentalOtherCharges;
          }),
          catchError(this.handleError)
        );
   }

   saveFirstRentalSettings(rentalSettings): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/admin/Setup/SaveRentalSettings`;
    return this.http.post<any>(url, rentalSettings, options)
      .pipe(
        map(res => {
          const response = res as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getAdvancedRentalSettings(marketId): Observable<boolean> {
    return this.http.get<any>(
        `${this.baseURL}/admin/Setup/GetAdvancedRentalSettings?marketId=` + marketId,
        { observe: 'response' })
        .pipe(
          map(res => {
            const rentalSettings = res.body as any;
            return rentalSettings;
          }),
          catchError(this.handleError)
        );
   }

   getTaxSettings(marketId): Observable<boolean> {
    return this.http.get<any>(
        `${this.baseURL}/admin/Setup/GetTaxSettings?marketId=` + marketId,
        { observe: 'response' })
        .pipe(
          map(res => {
            const taxSettings = res.body as any;
            return taxSettings;
          }),
          catchError(this.handleError)
        );
   }

   getPaymentSettings(marketId): Observable<boolean> {
    return this.http.get<any>(
        `${this.baseURL}/admin/Setup/GetPaymentSettings?marketId=` + marketId,
        { observe: 'response' })
        .pipe(
          map(res => {
            const paymentSettings = res.body as any;
            return paymentSettings;
          }),
          catchError(this.handleError)
        );
   }

   SavePaymentSettings(paymentSettings): Observable<boolean> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/admin/Setup/SavePaymentSettings`;
        return this.http.post<any>(url, paymentSettings, options)
          .pipe(
            map(res => {
              const response = res as any;
              return response;
            }),
            catchError(this.handleError)
          );
   }

   saveAdvancedRentalSettings(rentalSettings): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/admin/Setup/SaveAdvancedRentalSettings`;
    return this.http.post<any>(url, rentalSettings, options)
      .pipe(
        map(res => {
          const response = res as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }

  saveTaxSettings(rentalSettings): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/admin/Setup/SaveTaxSettings`;
    return this.http.post<any>(url, rentalSettings, options)
      .pipe(
        map(res => {
          const response = res as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getOtherSettings(marketId): Observable<boolean> {
    return this.http.get<any>(
        `${this.baseURL}/admin/Setup/GetOtherRentalSettings?marketId=` + marketId,
        { observe: 'response' })
        .pipe(
          map(res => {
            const otherSettings = res.body as any;
            return otherSettings;
          }),
          catchError(this.handleError)
        );
   }

   getRevenueCodes(marketId): Observable<boolean> {
    return this.http.get<any>(
        `${this.baseURL}/General/GetRevenueCodes?marketId=` + marketId,
        { observe: 'response' })
        .pipe(
          map(res => {
            const revenueCode = res.body as any;
            return revenueCode;
          }),
          catchError(this.handleError)
        );
   }

   getParts(marketId): Observable<boolean> {
    return this.http.get<any>(
        `${this.baseURL}/General/GetParts?marketId=` + marketId,
        { observe: 'response' })
        .pipe(
          map(res => {
            const parts = res.body as any;
            return parts;
          }),
          catchError(this.handleError)
        );
   }

   getMonthEnds(dayOfWeek: string,marketId): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseURL}/admin/Setup/GetMonthEnds?dayOfWeek=${dayOfWeek}&marketId=` + marketId);
  }

   saveOtherRentalSettings(rentalSettings): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/admin/Setup/SaveOtherRentalSettings`;
    return this.http.post<any>(url, rentalSettings, options)
      .pipe(
        map(res => {
          const response = res as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }

  SaveMonthEndDates(monthEndDates): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/admin/Setup/SaveMonthEndDates`;
    return this.http.post<any>(url, monthEndDates, options)
      .pipe(
        map(res => {
          const response = res as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }
     
  getArrReminderUsers(marketId: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/Employee/GetBtUsers?marketId=${marketId}`, { observe: 'response' })
      .pipe(
        map(res => res.body),
        catchError(this.handleError)
      );
  }

   private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
     // this.appinsights.logEvent(errMessage);
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
}
